export const ARTICLE_CARD_GRID_CLASS =
  "flex flex-wrap items-stretch justify-center gap-6 lg:gap-8 [&>*]:w-full [&>*]:md:w-[calc(50%-1rem)] [&>*]:lg:w-[calc(33.333%-1.4rem)] [&>*]:xl:w-[calc(25%-1.5rem)]";
